/* The picks and the two top tiles: chips, the pool profile, the duration line, In Your Hands.
 *
 * Every card carries its options as JSON (data-opts, from snippets/aps-pick-options.liquid)
 * and the fields the script rewrites as data- hooks (snippets/aps-pick-card.liquid). The page
 * is painted server side for one option, so nothing here is load bearing for a shopper with
 * script off: they see the recommended option and can add it.
 *
 * The profile lives in session storage under aps:pool as {gallons, sanitizer, surface}, the
 * object the parts finder will read later. Gallons is the only field anything reads today.
 *
 * In Your Hands: <aps-when> (assets/aps-when.js) reads its SKU once when it connects, so a
 * chip change replaces the element rather than editing it. The FREE rule is the same test the
 * product page makes: price at or above the block's free delivery threshold.
 *
 * One function scope: the header's and the search's scripts are classic scripts too.
 */
(() => {
  var KEY = 'aps:pool';
  var CHECK = '<svg viewBox="0 0 24 24" aria-hidden="true" class="ic"><path d="m4.8 12.4 4.9 4.9L19.2 6.9"/></svg>';
  var ALERT = '<svg viewBox="0 0 24 24" aria-hidden="true" class="ic"><circle cx="12" cy="12" r="9"/><path d="M12 8v4.5M12 16h.01"/></svg>';
  var BOLT = '<svg viewBox="0 0 20 24" aria-hidden="true"><path d="M12.6 1 2.5 13.6h6.2L6.9 23l10.6-13.3h-6.3z"/></svg>';
  var fmt = window.Shopify && Shopify.currency ? null : null;

  function readProfile() {
    try { return JSON.parse(sessionStorage.getItem(KEY)) || {}; } catch (e) { return {}; }
  }
  function writeProfile(p) {
    try { sessionStorage.setItem(KEY, JSON.stringify(p)); } catch (e) { /* private mode: the page still works */ }
  }
  function money(cents) {
    var d = Math.floor(cents / 100), c = cents % 100;
    return '$' + d.toLocaleString() + '<sup>' + (c < 10 ? '0' : '') + c + '</sup>';
  }
  function flat(cents) { return '$' + (cents / 100).toFixed(2); }
  function lasts(o, gal) {
    if (!o.dose || !o.rate) return '';
    var per = gal / 10000, g = gal.toLocaleString(), weeks = o.dose / (o.rate * per);
    if (o.kind === 'tab') {
      var w = Math.floor(weeks);
      return w >= 1 ? 'Lasts about <b>' + w + ' week' + (w === 1 ? '' : 's') + '</b> on a ' + g + ' gal pool' : 'Under a week on a ' + g + ' gal pool';
    }
    if (weeks >= 1) { var r = Math.floor(weeks); return '<b>' + r + ' weekly shock' + (r === 1 ? '' : 's') + '</b> for a ' + g + ' gal pool'; }
    return 'Takes <b>' + Math.ceil((o.rate * per) / o.dose) + ' bags</b> per shock on a ' + g + ' gal pool';
  }
  function recommended(opts, gal) {
    for (var i = 0; i < opts.length; i++) {
      var u = opts[i].upto;
      if (u === 0) continue;
      if (u === null || gal <= u) return i;
    }
    return 0;
  }

  function whenLine(root, o) {
    var free = +root.dataset.freeCents > 0 && o.price >= +root.dataset.freeCents;
    var el = document.createElement('aps-when');
    el.className = 'when-line pk-when';
    el.dataset.sku = o.sku; el.dataset.channel = root.dataset.channel || '16';
    var tier = o.avail ? '<span class="tier" data-aps-tier data-free="' + free + '" hidden>' + BOLT + '<b data-aps-tier-label></b></span>' : '';
    el.innerHTML = tier + '<span class="when-text"><span class="when-pre">' + (free ? root.dataset.freeLabel : root.dataset.paidLabel) + '</span> <b data-aps-when-date></b></span>';
    return el;
  }

  function paint(card, i, gal) {
    var root = card.closest('[data-aps-picks]') || card;
    var opts = card.__opts, o = opts[i], rec = recommended(opts, gal);
    card.dataset.on = i;
    var q = function (sel) { return card.querySelector(sel); };
    card.querySelectorAll('[data-chip]').forEach(function (c, k) {
      c.classList.toggle('on', k === i); c.classList.toggle('rec', k === rec); c.setAttribute('aria-pressed', k === i);
    });
    var role = q('[data-role]');
    if (role && card.dataset.fixedRole !== '1') role.textContent = i === rec ? (root.dataset.roleTpl || 'Our pick for a [gallons] gal pool').replace('[gallons]', gal.toLocaleString()) : '';
    var t = q('[data-title]'); if (t) { var a = t.querySelector('a') || t; a.textContent = o.title; if (a.tagName === 'A') a.href = o.url; }
    var why = q('[data-why]'); if (why) why.textContent = o.why;
    var img = q('[data-img]'); if (img && o.img) img.src = o.img;
    var pr = '<span class="now">' + money(o.price) + '</span>';
    if (o.was > o.price) pr += '<span class="was">' + flat(o.was) + '</span><span class="off">' + (root.dataset.saveLabel || 'Save [pct]%').replace('[pct]', Math.round((o.was - o.price) / o.was * 100)) + '</span>';
    q('[data-prow]').innerHTML = pr;
    var unit = q('[data-unit]'); if (unit) unit.textContent = o.unit || '';
    var ls = q('[data-lasts]'); if (ls) ls.innerHTML = lasts(o, gal);
    var slot = q('[data-when-slot]'); if (slot) { slot.innerHTML = ''; if (o.sku) slot.appendChild(whenLine(root, o)); }
    var av = q('[data-av]');
    if (av) {
      var low = o.avail && o.track && o.inv > 0 && o.inv <= (+root.dataset.lowAt || 10);
      av.className = 'av' + (!o.avail ? ' out' : low ? ' low' : '');
      av.innerHTML = !o.avail ? ALERT + root.dataset.outLabel : low ? ALERT + (root.dataset.lowLabel || 'Only [n] left').replace('[n]', o.inv) : CHECK + root.dataset.inLabel;
    }
    var vid = q('[data-vid]'); if (vid) vid.value = String(o.vid);
    var btn = q('[data-add] button'); if (btn) { btn.disabled = !o.avail; btn.textContent = o.avail ? root.dataset.addLabel : root.dataset.outLabel; }
  }

  function gallons() {
    var p = readProfile();
    if (p.gallons) return +p.gallons;
    var sel = document.querySelector('[data-aps-gal]');
    return sel ? +sel.value : 20000;
  }

  function init() {
    var cards = [].slice.call(document.querySelectorAll('[data-opts]'));
    cards.forEach(function (card) {
      try { card.__opts = JSON.parse(card.dataset.opts); } catch (e) { card.__opts = []; }
      if (!card.__opts.length) return;
      var chips = card.querySelector('[data-chips]');
      if (chips && card.__opts.length > 1) {
        var esc = function (t) { return String(t).replace(/[&<>]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;' }[c]; }); };
        var seen = {};
        chips.innerHTML = card.__opts.map(function (o, k) {
          var g = o.group && !seen[o.group] ? (seen[o.group] = true, '<span class="grp">' + esc(o.group) + '</span>') : '';
          return g + '<button class="chip" type="button" data-chip="' + k + '" aria-pressed="false">' + esc(o.label) + '</button>';
        }).join('');
        chips.addEventListener('click', function (ev) {
          var b = ev.target.closest('[data-chip]'); if (!b) return;
          paint(card, +b.dataset.chip, gallons());
        });
      }
      paint(card, recommended(card.__opts, gallons()), gallons());
    });

    var gal = document.querySelector('[data-aps-gal]'), san = document.querySelector('[data-aps-san]'), srf = document.querySelector('[data-aps-srf]');
    var saved = readProfile();
    if (gal && saved.gallons && [].some.call(gal.options, function (o) { return +o.value === +saved.gallons; })) gal.value = saved.gallons;
    if (san && saved.sanitizer) san.value = saved.sanitizer;
    if (srf && saved.surface) srf.value = saved.surface;
    function apply() {
      var g = gal ? +gal.value : 20000;
      writeProfile({ gallons: g, sanitizer: san ? san.value : '', surface: srf ? srf.value : '' });
      cards.forEach(function (card) { if (card.__opts && card.__opts.length) paint(card, recommended(card.__opts, g), g); });
    }
    var btn = document.querySelector('[data-aps-apply]');
    if (btn) btn.addEventListener('click', apply);
    if (gal) gal.addEventListener('change', apply);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
